// SHARED-011: Boot scene — basic config then transition to PreloadScene
import Phaser from 'phaser';

export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'BootScene' });
  }

  preload(): void {
    // Minimal assets needed for the loading screen can be loaded here
  }

  create(): void {
    // Set game-wide settings
    this.scale.refresh();
    this.scene.start('PreloadScene');
  }
}
